import { TechDetailsForm } from './tech-details';
import { DescriptionForm } from './description';
import { DocumentationForm } from './documentation';

export const appTabsContent = [
  {
    title: 'developer_portal_app_details_tab_tech_details',
    content: TechDetailsForm,
  },
  {
    title: 'developer_portal_app_details_tab_description',
    content: DescriptionForm,
  },
  {
    title: 'developer_portal_app_details_tab_documentation',
    content: DocumentationForm,
  },
];
